import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HTTPService } from 'src/app/services/http.service';
import { Observable, tap } from 'rxjs';



export interface DialogData {
  codecompany: any;
  idUser: any,
  codecontract:any,
  temporaryFiles:any,
  selectedImages:any,
  uploadedImageUrls:any

}

@Component({
    selector: 'image-selector',
    templateUrl: './image-selector.component.html',
    styleUrls: ['./image-selector.component.scss'],
    encapsulation: ViewEncapsulation.None // Desativa a encapsulação de view
    ,
    standalone: false
})




export class ImageSelectorComponent implements OnInit {


 
  image =  this.sanitizer.bypassSecurityTrustUrl( "assets/image/camera_create_icon.png");

  codecompany:Number;
  codecontract:Number;
  idUser:any;
  uploadedImageUrls: string[] = [];
  uploadProgress: number = 0;
  filesUploaded = 0;



  //quantidade de imagens permitidas no caso 8 por causa da amazon, depois podemos alterar. main_product_image_locator other_product_image_locator_1-8
  iconList: string[] = [ 
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
    'add_a_photo',
  ];

  
  temporaryFiles: File[] = [];
  selectedImage: string = null;
  selectedImages: (string | null)[] = new Array(this.iconList.length).fill(null);



  @Output() imageSelected = new EventEmitter<String>();

  constructor(
    public dialogRef: MatDialogRef<ImageSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private snackService:SnackbarService,
    private dialog:DialogService,    
    private sanitizer:DomSanitizer,
    private http:HTTPService,
    private cdr:ChangeDetectorRef
    ) { 

      this.sanitizer.bypassSecurityTrustUrl('assets/image/camera_create_icon.png');

    }
  
  
  ngOnInit(): void {
      

      if(this.data.selectedImages){
        this.selectedImages = this.data.selectedImages;
      }

      if(this.data.temporaryFiles){
        this.temporaryFiles =  this.data.temporaryFiles;
      }

      if(this.data.uploadedImageUrls){
        this.uploadedImageUrls = this.data.uploadedImageUrls;
      }

    
  }

  ngOnDestroy(){    

  }

  

  selectIcon(iconIndex: number) {
    this.selectedImages[iconIndex] = null;
  }

  uploadImage(event: any, iconIndex: number) {
    const file = event.target.files[0];

    if (!file.name.endsWith('.png') && !file.name.endsWith('.jpg')) {
      throw Error('Só é possível importar um arquivo do tipo PNG ou JPG!');
    }
    
    const lowestAvailableIndex = this.temporaryFiles.findIndex(file => !file);

    const targetIndex = lowestAvailableIndex !== -1 ? lowestAvailableIndex : this.temporaryFiles.length;
  

    this.temporaryFiles[targetIndex] = file;
    
    const reader = new FileReader();

    reader.onload = (e) => {
      this.selectedImages[targetIndex] = e.target.result as string;
      this.imageSelected.emit(this.selectedImages[targetIndex]);
    };
    reader.readAsDataURL(file);
  }

  removeImage(iconIndex: number) {
    this.selectedImages[iconIndex] = null;
    this.imageSelected.emit(null);
    

    if(this.uploadedImageUrls[iconIndex]){
      this.removeFromS3(this.temporaryFiles[iconIndex], iconIndex);      
      this.temporaryFiles.splice(iconIndex, 1);
      this.uploadedImageUrls.splice(iconIndex, 1);    
    }else{
      this.temporaryFiles.splice(iconIndex, 1);
    }

  }


  closeDialog() {
   
  }

  
 /* uploadToS3() { //Mover depois essa função para fora do componente para ele poder ser utilizado em outros locais.
    this.temporaryFiles.forEach((file, index) => {
      if (file) {
        this.uploadToS3Single(file, index);
      }
    });
  }*/

  uploadToS3() {
    const totalFiles = this.temporaryFiles.length;
    this.filesUploaded = 0;


    if(totalFiles > 0){
      this.temporaryFiles.forEach((file, index) => {
        if (file) {
          this.uploadToS3Single(file, index).subscribe(
            event => {
              if ( this.filesUploaded != totalFiles) {
                this.uploadProgress = Math.round((this.uploadedImageUrls.length / totalFiles) * 100);              
              } else if(this.filesUploaded === totalFiles){                              
                  this.snackService.showSuccess("Todas as fotos foram importadas!");
                  this.dialogRef.close({
                    selectedImages: this.selectedImages,
                    temporaryFiles: this.temporaryFiles,
                    uploadedImageUrls: this.uploadedImageUrls
                  });              
              }
            },
            error => {
              this.snackService.showError(error.message);
            }
          );
        }
      });
    }else{
      this.dialogRef.close({
        selectedImages: this.selectedImages,
        temporaryFiles: this.temporaryFiles,
        uploadedImageUrls: this.uploadedImageUrls
      });              
    }
  
   
  }

  private removeFromS3(file: File, iconIndex: number){

    if(file == null){
      throw Error('É necessário fazer upload da foto para salvar!');
    }

    if (this.data.codecompany == null) {
      throw Error('Empresa não configurada!');
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('FILENAME', file.name);
    formData.append('IDUSER', this.data.idUser);
    formData.append('CODECOMPANY', this.data.codecompany.toString());

    this.http.postFile(formData, "AmazonServices/removeFile", false, true, false).subscribe(
      event => {
        if (event.status === 'progress') {
        } else {

          if (event.resultado) {

            //this.snackService.showSuccess("Foto importada!");           
          }

          console.log('Upload response:', event);
        }
      },
      error => {
        console.error('Upload error:', error);
        this.snackService.showError(error.message);
      }
    );
  }
  
  

  private uploadToS3Single(file: File, iconIndex: number):Observable<any>  { //Mover depois essa função para fora do componente para ele poder ser utilizado em outros locais.

    if(file == null){
      throw Error('É necessário fazer upload da foto para salvar!');
    }

    if (this.data.codecompany == null) {
      throw Error('Empresa não configurada!');
    }

    const formData = new FormData();
    formData.append('image', file);
    formData.append('FILENAME', file.name);
    formData.append('IDUSER', this.data.idUser);
    formData.append('CODECOMPANY', this.data.codecompany.toString());
    //formData.append('CODECONTRACT', this.data.codecontract.toString()); depois ver se precisamos do codecontract


    return this.http.postFile(formData, "AmazonServices/uploadfile", false, true, false).pipe(
      tap((response: any) => {
        if (response.resultado) {
          this.uploadedImageUrls[iconIndex] = response.resultado;
          this.filesUploaded++;
        }
      })
    );
  }
    /*this.http.postFile(formData, "AmazonServices/uploadfile", false, true, false).subscribe(
      event => {
        if (event.status === 'progress') {
          console.log('Upload progress:', event.message);
        } else {

          if (event.resultado) {
            console.log(event.resultado);
            this.snackService.showSuccess("Foto importada!");
           // this.temporaryFiles[iconIndex] = null; ver depois se temos q limpar a lista de arquivos temporarios, pois se o cara deletar o ideal é remover da amazon
          }

          console.log('Upload response:', event);
        }
      },
      error => {
        console.error('Upload error:', error);
        this.snackService.showError(error.message);
      }
    );
  } */
}


